import { showErrorToast, showSuccessToast } from "./toast";

function isEmptyString(str) {
  // Trim the string to remove leading and trailing spaces
  const trimmedStr = str.trim();
  // Check if the trimmed string is empty
  return trimmedStr === "";
}

const isValidEmail = (email) => {
  return String(email)
    .trim()
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

function isEmpty(data) {
  return data.length === 0;
}

function copyToClipboard(text, description) {
  // Clipboard API supported
  navigator.clipboard
    .writeText(text)
    .then(() => {
      showSuccessToast(description || "Copied")
    })
    .catch((err) => {
      showErrorToast("Failed to copy text")
    });
}

function formatCurrency(amount, currency = "USD", locale = "en-US") {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(amount);
}

function toReadableNumber(num) {
  if (Math.abs(num) < 1 && num !== 0) {
    return Number(num).toFixed(10).replace(/\.?0+$/, ""); // trim trailing zeros
  }

  return Number(num).toLocaleString("en-US", { maximumFractionDigits: 10 });
}

export {
  isEmptyString,
  isValidEmail,
  copyToClipboard,
  isEmpty,
  formatCurrency,
  toReadableNumber
};
